import React from 'react';
import Card3D from '../../ui/Card3D';

interface Benefit {
  value: string;
  label: string;
}

interface ServiceBenefitsProps {
  title: string;
  benefits: Benefit[];
  color: string;
}

const ServiceBenefits: React.FC<ServiceBenefitsProps> = ({ title, benefits, color }) => {
  return (
    <section className="mb-16">
      <h2 className="text-2xl font-bold mb-8">{title}</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {benefits.map((benefit, index) => (
          <Card3D key={index}>
            <div className="bg-white p-6 rounded-xl h-full">
              <div className="text-2xl font-bold mb-2" style={{ color }}>
                {benefit.value}
              </div>
              <div className="text-gray-600">
                {benefit.label}
              </div>
            </div>
          </Card3D>
        ))}
      </div>
    </section>
  );
};

export default ServiceBenefits;